<script lang="ts">
  export let label: string;
  export let value: boolean | string = false;
  export let isDisabled: boolean = false;
  export let invalidMessage: string | undefined = undefined;
  export let onChange: (value: boolean) => void = () => {
    "do nothing";
  };

  let clazz = "";
  export { clazz as class };

  const toggleValue = () => {
    if (isDisabled) return;
    value = !value;
    onChange(value);
  };
</script>

<button
  class={`my-2 w-full ${clazz || ""}`}
  class:cursor-pointer={!isDisabled}
  class:cursor-not-allowed={isDisabled}
  on:click={toggleValue}>
  <div class="flex gap-3 font-medium">
    <div class="checkbox" class:checked={!!value} class:invalid-input={invalidMessage}>✓</div>
    <span class="w-full text-justify label">{@html label}</span>
  </div>
  {#if invalidMessage}
    <p class="invalid-message text-xs mt-1 text-left">{invalidMessage}</p>
  {/if}
</button>

<style>
  .invalid-input {
    border: 1px solid var(--color-red-20);
  }

  .invalid-message {
    color: var(--color-red-50);
  }

  .checkbox {
    width: 1.5rem;
    height: 1.5rem;
    background-color: var(--color-grayscale-20);
    color: var(--color-grayscale-20);
    border-radius: 0.25rem;
    transition: all 0.2s;
  }

  .checkbox.checked {
    background-color: var(--color-purple-50);
    color: white;
  }
</style>
